import { render, staticRenderFns } from "./LazadaDropoff.vue?vue&type=template&id=0f4cc64c&"
import script from "./LazadaDropoff.vue?vue&type=script&lang=js&"
export * from "./LazadaDropoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports